<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <img src="./assets/img/logoBanner.png" alt />
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="router"
        >
          <el-menu-item index="/" @click="Download('/')">首页</el-menu-item>
          <el-menu-item index="/news" @click="Download('/news')"
            >新闻资讯</el-menu-item
          >
          <el-menu-item index="/product" @click="Download('/product')"
            >产品中心</el-menu-item
          >
          <el-menu-item index="/case" @click="Download('/case')"
            >平台服务</el-menu-item
          >
          <el-menu-item index="/YaoPin" @click="Download('/YaoPin')"
            >药品展示</el-menu-item
          >
          <el-menu-item index="/Qixie" @click="Download('/Qixie')"
            >医疗器械</el-menu-item
          >
          <el-menu-item index="/goin" @click="Download('/goin')"
            >走进善信</el-menu-item
          >
          <el-menu-item index="/download" @click="Download('/download')"
            >下载APP</el-menu-item
          >
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <div class="footer" v-show="true">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <p>走进善信</p>
              <span>发展历程</span>
              <span>企业文化</span>
              <span>资质荣誉</span>
              <span>合作伙伴</span>
            </li>
            <li>
              <p>新闻资讯</p>
              <span>公司新闻</span>
              <span>行业动态</span>
            </li>
            <li>
              <p>产品中心</p>
              <span>介绍视频</span>
              <span>管理模式</span>
              <span>平台目标</span>
              <span>功能模块</span>
            </li>
            <li>
              <p>联系我们</p>
              <span>邮箱：397626534@qq.com</span>
              <span>电话：0392-3605688</span>
              <span>地址：河南省鹤壁市金融大厦7层河南善信医养科技有限公司</span>
            </li>
          </ul>
          <img src="./assets/img/ercode.jpg" alt />
        </div>
        <div class="copyright">
          <p>CopyRight © 2016-2024</p>
          <P>河南善信医养科技有限公司 版权所有</P>
          <p
            @click="ToWY('https://beian.miit.gov.cn/#/Integrated/recordQuery')"
          >
            ICP备案主体信息:豫ICP备2023025629号 河南善信医养科技有限公司
          </p>
          <p>
            <span
              @click="
                ToWY('https://beian.miit.gov.cn/#/Integrated/recordQuery')
              "
              >ICP备案服务信息:豫ICP备2023025629号-1</span
            >
            网站域名:
            <span @click="ToWY('https://shanxinyy.com/')">shanxinyy.com</span>
          </p>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: localStorage.getItem("defaultActive") || "/",
      isShow: false,
    };
  },
  methods: {
    ToWY(url) {
      location.href = url;
    },
    Download(defaultActive) {
      this.defaultActive = defaultActive;
      localStorage.setItem("defaultActive", defaultActive);
    },
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    },
  },
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  font-size: 15px;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 1240px;
  margin: 0 auto;
  //background-color: #fff;

  .logo {
    width: 280px;
    padding: 10px;
    height: 50px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  background-color: rgb(255, 118, 64, 0.9);
  padding: 20px 0;
  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
        p {
          font-size: 17px;
          color: #d4edff;
          padding: 10px 0;
        }
        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
          font-size: 14px;
        }
      }
    }
    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }
  .copyright {
    line-height: 1.6;
    text-align: center;
    color: #fff;
    font-size: 15px;
  }
}
</style>